<!--
|--------------------------------------------------
|      询价管理-新增/修改数据弹窗
| 
| 
| 
|--------------------------------------------------
-->
<template>
<el-dialog :title="'查看供应商报价'" :append-to-body="true" :close-on-click-modal="false" width="80%" :visible.sync="visible">
    <part-price-tab ref="partPriceTab" :vender="vender" :dataForm="dataForm"></part-price-tab>
</el-dialog>
</template>

<script>
import PartPriceTab from '../quotation/quotation-part-price-tab'
export default {
    components: {
        PartPriceTab,
    },
    data() {
        return {
            /**  弹窗整体visible */
            visible: false,
            dataForm: {},
            vender: {}
        }
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            console.log(data, 'data')
            this.vender.id = id
            this.vender.venderName = data.rfqSupplierName
            this.vender.venderCode = data.rfqSupplierCode
            this.dataForm = data
            this.visible = true
            this.$nextTick(() => {
                this.$refs.partPriceTab.getAppartmentList(viewFlag, data.roundNo, data.rfqId)
            })
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}
</style>
